import React from 'react';

// /////////////////////////////////////////////////////////////////////////////////////////////////
const playerState = {
  cameraId: 0,
  videoLength: 0, // 0: 1 Minutes, 1: 2 Min, 2: 3 Min
  currentTime: 0,
  vehicle: null,
  videoUrl: '',
  imageUrl: '',
  isPlaying: false,
  isFetchingImageUrl: false,
  isFetchingImage: false,
  isVideoContinued: false,
  rotate: 0,
};

const playerItem = JSON.parse(localStorage.getItem('store.player')) || {};
playerState.cameraId = playerItem.cameraId ?? playerState.cameraId;
playerState.videoLength = playerItem.videoLength ?? playerState.videoLength;

const PlayerStore = (state = playerState, { type, ...rest }) => {
  switch (type) {
    case 'player/update':
      const newState = { ...state, ...rest };
      localStorage.setItem('store.player', JSON.stringify(newState));
      return newState;
    default:
      return state;
  }
};

export default PlayerStore;
